/** @jsx jsx */

import { Icon, Spacer, Spinner, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { LifecycleStage } from 'app/entities/VersionLifecycle/types';

const Styles = {
  root: css`
    display: flex;
    align-items: center;
    padding: 10px 0px 15px;
  `,
};

type Props = {
  stage: LifecycleStage;
};

const Status = ({ stage }: Props) => {
  const isRequested = stage === LifecycleStage.requested;
  const isEstimating = stage === LifecycleStage.estimating;
  // Progress is visible once we're past the estimation phase.
  const isInProgress = stage && !isRequested && !isEstimating;

  const statusLabel = isInProgress
    ? 'In progress'
    : isEstimating
    ? 'Estimating'
    : 'Queued';

  return (
    <title css={Styles.root}>
      {isInProgress ? (
        // While in progress, a progress bar is render in UI and a static icon is
        // used.
        <Icon name="miscUptime" size={18} />
      ) : (
        // Otherwise, we render a spinner to indicate that someting is running
        // since no progress bar exists in UI at this time.
        <Spinner />
      )}
      <Spacer width={10} />
      <Text type="Body4">Update Status: {statusLabel}</Text>
    </title>
  );
};

export default Status;
